import { render } from "./TimestampPage.vue?vue&type=template&id=0fe9db87&scoped=true"
import script from "./TimestampPage.vue?vue&type=script&lang=js"
export * from "./TimestampPage.vue?vue&type=script&lang=js"

import "./TimestampPage.vue?vue&type=style&index=0&id=0fe9db87&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe9db87"]])

export default __exports__